export const GET_PRODUCTS_QUERY = `
  query getProducts($first: Int, $query: String) {
    products(first: $first, query: $query) {
      edges {
        node {
          id
          title
          tags
          handle
          vendor
          productType
          totalInventory
          collections(first: 250) {
            nodes {
              handle
            }
          }
          featuredImage {
            url
          }
          priceRange {
            maxVariantPrice {
              amount
            }
            minVariantPrice {
              amount
            }
          }
        }
      }
    }
  }
`;

export const GET_REFILL_COLLECTION = `
  query GET_REFILL_COLLECTION {
    collectionByHandle(handle: "refillable-kits-loved-by-vs") {
      id
      title
      products(first: 250) {
        nodes {
          id
          title
          handle
           priceRange {
            minVariantPrice {
              amount
            }
          }
          featuredImage {
            url
          }
          specs: metafield(namespace: "custom", key: "product_features_accordion") {
            reference {
              ... on Metaobject {
                id
                type
                fields {
                  key
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PREFILL_COLLECTION = `
  query GET_REFILL_COLLECTION {
    collectionByHandle(handle: "prefilled-kits-loved-by-vs") {
      id
      title
      products(first: 250) {
        nodes {
          id
          title
          handle
          priceRange {
            minVariantPrice {
              amount
            }
          }
          featuredImage {
            url
          }
          specs: metafield(namespace: "custom", key: "product_features_accordion") {
            reference {
              ... on Metaobject {
                id
                type
                fields {
                  key
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`;
